import MetadataConcept from '@client/common/schema/metadataConcept';
import MetadataReadingSkill from '@client/common/schema/metadataReadingSkill';
import MetadataTopic from '@client/common/schema/metadataTopic';

export function metadataSelectors () {
  return [MetadataConcept.inputs.conceptTags, MetadataTopic.inputs.topicTags, MetadataReadingSkill.inputs.readingSkillTags];
}

export function getMetadataFields () {
  return `
      metadataCerticaConcepts { ...fullMetadataConcept }
      metadataCerticaTopics { ...fullMetadataTopic }
      metadataReadingSkills { ...fullMetadataReadingSkill }`;
}
